import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
} from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useUser } from '../../UserContext'
import * as yup from 'yup'
import { useModal } from '../../context/modal-context'

const ValidEmailModal = () => {
  const { openValidEmail, confirmEmail } = useModal()

  const { user } = useUser()

  const schema = yup.object({
    email: yup
      .string()
      .email('Email inválido')
      .required('El email es obligatorio')
      .test('match-user-email', 'El email debe coincidir con tu cuenta', function (value) {
        return value === user?.email
      }),
  })

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(schema),
  })
  const onSubmit = async data => {
    confirmEmail(data.email)
    reset()
  }
  const onCancel = async () => {
    confirmEmail(null)
    reset()
  }
  if (!user) {
    return null
  }
  return (
    <Dialog open={openValidEmail} onClose={onCancel}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Registrar Email</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>
            Registra tu email para recibir un código de 6 dígitos.
          </Typography>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Email"
                fullWidth
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>Cancelar</Button>
          <Button type="submit" variant="contained">
            Registrar
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default ValidEmailModal
